<template>
  <b-modal 
    v-model="showModal"
    :title="cancelTitle"
    centered
    ok-title="Yes"
    cancel-title="No"
    @ok="submitCancel"
    @cancel="handleCancel"
    @hide="handleHide">
    Are you sure you want to cancel &quot;{{ bioreqDocument.title }}&quot;?
  </b-modal>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    bioreqDocument: {
      type: Object,
      required: true,
      default: null
    }
  },
  data() {
    return {
      modalIsVisible: false
    }
  },
  computed: {
    showModal: {
      get () {
        return this.visible
      },
      set (newValue) {
        this.modalIsVisible = newValue
      }
    },
    cancelTitle () {
      return `Confirm Cancel - ${this.bioreqDocument.title}`
    }
  },
  methods: {
    submitCancel (evt) {
      evt.preventDefault()
      this.$store.dispatch('bioreq/destroy', this.bioreqDocument.id)
      this.$emit('hide-cancel-modal')
    },
    handleCancel () {
      this.$emit('hide-cancel-modal')
    },
    handleHide () {
      this.$emit('hide-cancel-modal')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/client/bioreq/cancelModal.vue